import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import DrawDetail from "../Modal/DrawDetail";
import FreezeDetail from "../Modal/FreezeDetail";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { toast } from "react-toastify";
import {
  getMembersInfo,
  selectMembersInfo,
  selectMembersInfoLoading,
  selectMemberInfo,
  getDrawDetail,
  getFreezeDetail,
  getDocumentFile,
  selectDocumentFile,
  downloadCdnFile,
  downloadReportFile,
} from "../../../state/ducks/member/index";
import {
  fileUploadService,
  sendDocumentsForReviewService,
  getGuarantorsService,
  addGuarantorService,
  deleteGuarantorService,
  getMemberDeliveryDocumentsService,
  getCorporateCardOfficerService,
  saveDeliveryScopeSelectionService,
  saveServiceRecordService,
} from "../../../services/member.service"
import SalesDocumentUploadTab from "./SalesDocumentUploadTab";
import EminevimLoading from "../shared/EminevimLoading";

class Expenses extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.salesDocumentTabRef = React.createRef();
    this.state = {
      cekilisTarihi: null,
      uye: "ÜYELİK BİLGİLERİM",
      currency: "₺",
      selectedmobilDokumanTurId: null,
      isShowLoading: false,
      loadingSubtext: "İşleminiz gerçekleştiriliyor, lütfen bekleyiniz.",
      guarantors: [],
      guarantorsLoading: false,
      showAddGuarantorModal: false,
      showGuarantorChoiceModal: false,
      showGuarantorCriteriaWarningModal: false,
      showDeleteGuarantorModal: false,
      showCorporateOfficerModal: false,
      showOfficerGuarantorConfirmModal: false,
      corporateOfficers: [],
      corporateOfficersLoading: false,
      pendingOfficerGuarantor: null,
      isCorporateOfficerSelected: false,
      selectedGuarantorId: null,
      guarantorForm: {
        adi: "",
        soyadi: "",
        vatandaslikNo: "",
        gsm: "",
        dogumTarihi: "",
        kartId: 0
      },
      deliveryDocuments: null,
      deliveryDocumentsLoading: false,
      selectedOrgTypeId: "",
      selectedServiceRecordId: "",
      isChangingDeliveryScope: false,
      isChangingServiceRecord: false,
      showDeliveryDocumentsInfoModal: false,
      showDeliveryScopeConfirmModal: false,
      showServiceRecordGuarantorWarningModal: false,
      isShowGuarantors: false,
      isMemberTabsLoading: true,
      showSalesDocumentsTab: true,
    };
  }


  // Dosya seçilince çalışır
  handleFileChange = async (event) => {
    const file = event.target.files[0];
    const { selectedmobilDokumanTurId } = this.state;
    const maxFileSize = 8 * 1024 * 1024;

    if (!file || !selectedmobilDokumanTurId) return;

    if (file.size > maxFileSize) {
      toast.error("Dosya boyutu en fazla 8 MB olabilir");
      event.target.value = "";
      return;
    }

    const { match } = this.props;
    var memberId = match?.params?.id;

    const formData = new FormData();
    formData.append("File", file);
    formData.append("MobilDokumanTurId", selectedmobilDokumanTurId);
    formData.append("MemberId", memberId);

    // FormData içeriğini görmek için:
    for (let pair of formData.entries()) {
      console.log(pair[0], ":", pair[1]);
    }

    this.showPageLoading("Dosyanız yükleniyor, lütfen bekleyiniz.");
    fileUploadService(formData).then((result) => {
      this.hidePageLoading();
      console.log(result);
      if (result.success) {
        const { match } = this.props;
        var id = match?.params?.id;
        this.loadDeliveryDocuments(id);
        toast.success("Dosya yüklendi");

      } else {
        toast.error(result.message);
      }
    });

  };

  // “Yükle” tıklanınca file input'u tetikler
  handleUploadClick = (mobilDokumanTurId, e) => {
    e.preventDefault();
    this.setState({ selectedmobilDokumanTurId: mobilDokumanTurId }, () => {
      try {
        this.fileInputRef.current.click();
      } catch (error) {

      }
    });
  };

  componentDidMount() {
    const { match } = this.props;

    var id = match?.params?.id;
    this.props.getMembersInfo(id);

    let result = this.props.member.info.filter((item) => {
      return item.id.toString() === id;
    });

    if (result != null && result[0] != null) {
      this.setState({ uye: result[0] });
      this.setState({
        currency: result[0].orgTurId === 3 ? "XAU" : "₺",
      });
    }
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match?.params?.id;
    const nextId = this.props.match?.params?.id;

    if (prevProps.membersInfoLoading && !this.props.membersInfoLoading) {
      this.setState({ isMemberTabsLoading: false });
    }

    if (prevId !== nextId && nextId) {
      this.setState({ isMemberTabsLoading: true });
      this.props.getMembersInfo(nextId);

      const result = this.props.member.info.filter((item) => {
        return item.id.toString() === nextId;
      });

      if (result != null && result[0] != null) {
        this.setState({
          uye: result[0],
          currency: result[0].orgTurId === 3 ? "XAU" : "₺",
          showSalesDocumentsTab: true,
        });
      }
    }
  }

  showPageLoading = (loadingSubtext = "İşleminiz gerçekleştiriliyor, lütfen bekleyiniz.") => {
    this.setState({ isShowLoading: true, loadingSubtext });
  };

  hidePageLoading = () => {
    this.setState({ isShowLoading: false });
  };

  parseApiResult = (result) => {
    if (typeof result === "string") {
      try {
        return JSON.parse(result);
      } catch (error) {
        return null;
      }
    }

    return result;
  };

  normalizePhone = (value) => {
    let digits = (value || "").replace(/\D/g, "");
    if (digits.startsWith("90")) {
      digits = digits.slice(2);
    }
    digits = digits.replace(/^0+/, "");
    return digits.substring(0, 10);
  };

  formatPhone = (value) => {
    const digits = this.normalizePhone(value);
    const first = digits.slice(0, 3);
    const second = digits.slice(3, 6);
    const third = digits.slice(6, 8);
    const fourth = digits.slice(8, 10);
    return [first, second, third, fourth].filter(Boolean).join(" ");
  };

  formatDateInput = (value) => {
    const digits = (value || "").replace(/\D/g, "").slice(0, 8);
    const day = digits.slice(0, 2);
    const month = digits.slice(2, 4);
    const year = digits.slice(4, 8);

    if (digits.length <= 2) return day;
    if (digits.length <= 4) return `${day}/${month}`;
    return `${day}/${month}/${year}`;
  };

  convertDisplayDateToIso = (value) => {
    const match = (value || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return "";

    const [, dd, mm, yyyy] = match;
    const date = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
    if (
      Number.isNaN(date.getTime()) ||
      date.getFullYear() !== Number(yyyy) ||
      date.getMonth() + 1 !== Number(mm) ||
      date.getDate() !== Number(dd)
    ) {
      return "";
    }

    return `${yyyy}-${mm}-${dd}`;
  };

  convertIsoToDisplayDate = (value) => {
    if (!value) return "";

    const isoMatch = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      const [, yyyy, mm, dd] = isoMatch;
      return `${dd}/${mm}/${yyyy}`;
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  isCorporateCard = () => {
    const deliveryDocuments = this.state.deliveryDocuments;
    const bireyKurum = deliveryDocuments?.bireyKurum ?? deliveryDocuments?.BireyKurum;
    return Number(bireyKurum) === 2;
  };

  isFutureDisplayDate = (value) => {
    const isoDate = this.convertDisplayDateToIso(value);
    if (!isoDate) return false;

    const selectedDate = new Date(`${isoDate}T00:00:00`);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selectedDate > today;
  };

  loadGuarantors = () => {
    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;
    if (!uyelikId || this._guarantorsRequest) return;

    this._guarantorsRequest = true;
    this.setState({ guarantorsLoading: true });
    getGuarantorsService(uyelikId).then((result) => {
      const parsedResult = this.parseApiResult(result);
      const guarantors = parsedResult?.data || [];
      this.setState({ guarantors, guarantorsLoading: false });
    }).catch(() => {
      this.setState({ guarantors: [], guarantorsLoading: false });
    }).finally(() => {
      this._guarantorsRequest = false;
    });
  };

  getDeliveryDocumentsInfoHtml = (deliveryDocuments) => {
    return deliveryDocuments?.bilgilendirmeHtml || deliveryDocuments?.BilgilendirmeHtml || "";
  };

  openDeliveryDocumentsInfoModal = () => {
    this.setState({ showDeliveryDocumentsInfoModal: true });
  };

  closeDeliveryDocumentsInfoModal = () => {
    this.setState({ showDeliveryDocumentsInfoModal: false });
  };

  loadDeliveryDocuments = (memberId, showInfoModal = false) => {
    const id = memberId || this.props.match?.params?.id;
    if (!id || this._deliveryDocumentsRequest) return false;

    this._deliveryDocumentsRequest = true;
    this.hidePageLoading();
    this.setState({ deliveryDocumentsLoading: true });
    getMemberDeliveryDocumentsService(id).then((result) => {
      const parsedResult = this.parseApiResult(result);
      if (parsedResult?.success) {
        const data = parsedResult.data;
        const bilgilendirmeHtml = this.getDeliveryDocumentsInfoHtml(data);
        const showServiceRecordGuarantorWarning = this._showServiceRecordGuarantorWarningAfterLoad === true;
        this._showServiceRecordGuarantorWarningAfterLoad = false;
        this.setState({
          deliveryDocuments: data,
          deliveryDocumentsLoading: false,
          selectedOrgTypeId: data?.secilenOrgId ? String(data.secilenOrgId) : "",
          selectedServiceRecordId: data?.secilenHizmetTurId ? String(data.secilenHizmetTurId) : "",
          isChangingDeliveryScope: false,
          isChangingServiceRecord: false,
          showDeliveryDocumentsInfoModal: showInfoModal && !!bilgilendirmeHtml && data?.secilenOrgId === 2,
          showServiceRecordGuarantorWarningModal: showServiceRecordGuarantorWarning,
          isShowGuarantors: data.kefilEkleyebilir,
          guarantorsLoading: data?.ekranTuru === 3
        });
        if (data?.ekranTuru === 3) {
          this.loadGuarantors();
        }
      } else {
        this._showServiceRecordGuarantorWarningAfterLoad = false;
        this.setState({ deliveryDocumentsLoading: false });
        toast.error(parsedResult?.message || "Dokümanlar yüklenemedi");
      }
    }).catch(() => {
      this._showServiceRecordGuarantorWarningAfterLoad = false;
      this.setState({ deliveryDocumentsLoading: false });
      toast.error("Dokümanlar yüklenemedi");
    }).finally(() => {
      this._deliveryDocumentsRequest = false;
      this.hidePageLoading();
    });
    return true;
  };

  handleDeliveryDocumentsTabClick = () => {
    this.setState({ isChangingDeliveryScope: false, isChangingServiceRecord: false });
    this.loadDeliveryDocuments(undefined, true);
  };

  handleSalesDocumentsTabClick = () => {
    const salesDocumentTab = this.salesDocumentTabRef.current;
    if (salesDocumentTab) {
      salesDocumentTab.loadRequests();
    }
  };

  handleSalesDocumentsListLoaded = ({ isActive }) => {
    if (isActive === false) {
      this.setState({ showSalesDocumentsTab: false });
    }
  };

  openDeliveryDocumentsInfo = () => {
    const bilgilendirmeHtml = this.getDeliveryDocumentsInfoHtml(this.state.deliveryDocuments);
    if (bilgilendirmeHtml) {
      this.openDeliveryDocumentsInfoModal();
      return;
    }

    this.loadDeliveryDocuments(undefined, true);
  };

  handleDeliveryDocumentsInfoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.openDeliveryDocumentsInfo();
  };

  openChangeDeliveryScope = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingDeliveryScope: true,
      selectedOrgTypeId: deliveryDocuments?.secilenOrgId ? String(deliveryDocuments.secilenOrgId) : ""
    });
  };

  cancelChangeDeliveryScope = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingDeliveryScope: false,
      selectedOrgTypeId: deliveryDocuments?.secilenOrgId ? String(deliveryDocuments.secilenOrgId) : ""
    });
  };

  handleSaveDeliveryScopeClick = () => {
    const { selectedOrgTypeId, isChangingDeliveryScope } = this.state;

    if (!selectedOrgTypeId) {
      toast.error("Lütfen teslimat kapsamını seçiniz");
      return;
    }

    if (isChangingDeliveryScope) {
      this.setState({ showDeliveryScopeConfirmModal: true });
      return;
    }

    this.saveDeliveryScopeSelection();
  };

  closeDeliveryScopeConfirmModal = () => {
    this.setState({ showDeliveryScopeConfirmModal: false });
  };

  confirmSaveDeliveryScopeSelection = () => {
    this.setState({ showDeliveryScopeConfirmModal: false }, () => {
      this.saveDeliveryScopeSelection();
    });
  };

  saveDeliveryScopeSelection = () => {
    const { match } = this.props;
    const memberId = match?.params?.id;
    const { selectedOrgTypeId } = this.state;

    if (!selectedOrgTypeId) {
      toast.error("Lütfen teslimat kapsamını seçiniz");
      return;
    }

    this.showPageLoading("Teslimat doküman bilgileriniz hazırlanıyor, lütfen bekleyiniz.");
    saveDeliveryScopeSelectionService(memberId, selectedOrgTypeId).then((result) => {
      const parsedResult = this.parseApiResult(result);
      if (parsedResult?.success) {
        toast.success("Teslimat kapsamı kaydedildi");
        if (!this.loadDeliveryDocuments(memberId)) {
          this.hidePageLoading();
        }
      } else {
        this.hidePageLoading();
        toast.error(parsedResult?.message || "Kayıt yapılamadı");
      }
    }).catch(() => {
      this.hidePageLoading();
      toast.error("Kayıt yapılamadı");
    });
  };

  openChangeServiceRecord = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingServiceRecord: true,
      selectedServiceRecordId: deliveryDocuments?.secilenHizmetTurId
        ? String(deliveryDocuments.secilenHizmetTurId)
        : "",
    });
  };

  cancelChangeServiceRecord = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingServiceRecord: false,
      selectedServiceRecordId: deliveryDocuments?.secilenHizmetTurId
        ? String(deliveryDocuments.secilenHizmetTurId)
        : "",
    });
  };

  handleSaveServiceRecordClick = () => {
    const { selectedServiceRecordId } = this.state;

    if (!selectedServiceRecordId) {
      toast.error("Lütfen hizmet dökümü türünü seçiniz");
      return;
    }

    this.saveServiceRecordSelection();
  };

  shouldShowServiceRecordGuarantorWarning = (serviceRecordId) => {
    return serviceRecordId === "1" || serviceRecordId === "2";
  };

  closeServiceRecordGuarantorWarningModal = () => {
    this.setState({ showServiceRecordGuarantorWarningModal: false });
  };

  saveServiceRecordSelection = () => {
    const { match } = this.props;
    const memberId = match?.params?.id;
    const { selectedServiceRecordId } = this.state;

    if (!selectedServiceRecordId) {
      toast.error("Lütfen hizmet dökümü türünü seçiniz");
      return;
    }

    this.showPageLoading("Teslimat doküman bilgileriniz hazırlanıyor, lütfen bekleyiniz.");
    saveServiceRecordService(memberId, selectedServiceRecordId).then((result) => {
      const parsedResult = this.parseApiResult(result);
      const showGuarantorWarning = this.shouldShowServiceRecordGuarantorWarning(selectedServiceRecordId);

      if (parsedResult?.success) {
        toast.success(parsedResult?.message || "Hizmet dökümü kaydedildi");
        this._showServiceRecordGuarantorWarningAfterLoad = showGuarantorWarning;
        if (!this.loadDeliveryDocuments(memberId)) {
          this.hidePageLoading();
        }
      } else {
        this.hidePageLoading();
        toast.error(parsedResult?.message || "Kayıt yapılamadı");
      }
    }).catch(() => {
      this.hidePageLoading();
      toast.error("Kayıt yapılamadı");
    });
  };

  renderServiceRecordGuarantorWarningModal = () => {
    const { showServiceRecordGuarantorWarningModal } = this.state;

    if (!showServiceRecordGuarantorWarningModal) return null;

    return (
      <>
        <div className="modal fade show" style={{ display: "block", zIndex: 1004 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
              <div
                className="modal-header border-0"
                style={{ backgroundColor: "#fff7ed", color: "#7c2d12", borderBottom: "1px solid #fed7aa" }}
              >
                <h5 className="modal-title mb-0">Bilgilendirme</h5>
                <button type="button" className="close" onClick={this.closeServiceRecordGuarantorWarningModal}>
                  <span style={{ color: "#9a3412" }}>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ backgroundColor: "#fffbeb", padding: 24, fontSize: "11pt", color: "#585858" }}>
                Gelir belgesi yüklenmediği için devam edebilmeniz adına kefil eklemeniz gerekmektedir.
              </div>
              <div className="modal-footer border-0 justify-content-center" style={{ backgroundColor: "#fffbeb", paddingTop: 8, paddingBottom: 20 }}>
                <button
                  type="button"
                  className="btn btn-light border px-4"
                  style={{ borderRadius: 10, backgroundColor: "#339f53", color: "white" }}
                  onClick={this.closeServiceRecordGuarantorWarningModal}
                >
                  ANLADIM
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1003 }}></div>
      </>
    );
  };

  renderDeliveryDocumentsInfoModal = () => {
    const { showDeliveryDocumentsInfoModal, deliveryDocuments } = this.state;
    const bilgilendirmeHtml = this.getDeliveryDocumentsInfoHtml(deliveryDocuments);

    if (!showDeliveryDocumentsInfoModal || !bilgilendirmeHtml) return null;

    return (
      <>
        <div className="modal fade show" style={{ display: "block", zIndex: 1003 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
              <div
                className="modal-header border-0"
                style={{ backgroundColor: "#f8fafc", color: "#585858", borderBottom: "1px solid #e2e8f0" }}
              >
                <h5 className="modal-title mb-0">Muvafakatname ve Nüfus Kayıt Örneğini Nasıl Alırım ?</h5>
                <button type="button" className="close" onClick={this.closeDeliveryDocumentsInfoModal}>
                  <span style={{ color: "#585858" }}>&times;</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ backgroundColor: "#ffffff", padding: 24, maxHeight: "70vh", overflowY: "auto" }}
                dangerouslySetInnerHTML={{ __html: bilgilendirmeHtml }}
              />
              <div className="modal-footer border-0 justify-content-center" style={{ backgroundColor: "#f8fafc", paddingTop: 8, paddingBottom: 20 }}>
                <button
                  type="button"
                  className="btn btn-light border px-4"
                  style={{ borderRadius: 10, backgroundColor: "#339f53", color: "white" }}
                  onClick={this.closeDeliveryDocumentsInfoModal}
                >
                  ANLADIM
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1002 }}></div>
      </>
    );
  };

  renderDeliveryStatusAlert = (deliveryDocument) => {
    if (!deliveryDocument?.durumMesaj) return null;

    return (
      <div
        className="t-icSssCerceve"
        style={{
          border: `1px solid ${deliveryDocument.durumRenkKodu}`,
          backgroundColor: `${deliveryDocument.durumRenkKodu}54`,
          padding: "8px 30px"
        }}
      >
        <div className="row no-gutters">
          <div className="col-12">
            <strong style={{ color: deliveryDocument.durumRenkKodu, fontSize: "11pt" }}>DURUM</strong>
            <br />
          </div>
          <div className="col" style={{ fontSize: "10pt", color: "#585858", textAlign: "left" }}>
            {deliveryDocument.durumMesaj}
          </div>
        </div>
      </div>
    );
  };

  renderDeliveryScopeSelection = () => {
    const { deliveryDocuments, selectedOrgTypeId, isChangingDeliveryScope } = this.state;
    const selectedLabel = selectedOrgTypeId === "1" ? "Araç" : selectedOrgTypeId === "2" ? "Ev/İş Yeri" : "";
    const themeClass = selectedOrgTypeId === "1" ? "t-memberDetail-header--blue" : "t-memberDetail-header--green";

    return (
      <>
        {this.renderDeliveryStatusAlert(deliveryDocuments)}
        <article className={`t-memberInfo-card t-deliverySelectCard ${themeClass}`}>
          <div className="t-memberInfo-cardInner">
            <div className="t-memberInfo-cardHeader">
              <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                <i className={selectedOrgTypeId === "1" ? "t-icon-truck1" : "t-icon-home1"} aria-hidden="true" />
              </div>
              <div className="t-memberInfo-cardHeaderContent">
                <div className="t-memberInfo-cardTitleRow">
                  <h2 className="t-memberInfo-cardTitle">Teslimat Kapsamını Seçiniz</h2>
                  {selectedLabel && <span className="t-memberInfo-typeChip">{selectedLabel}</span>}
                </div>
                <div className="t-memberInfo-cardBadges">
                  <span className="t-memberDetail-headerBadge">Teslimat Dosyası</span>
                </div>
              </div>
            </div>

            <p className="t-deliverySelectPanel-text">
              Teslimat dosyanızın doğru şekilde oluşturulabilmesi için teslimata konu olacak varlık türünü seçiniz. Seçiminize göre talep edilecek belge ve değerlendirme süreçleri farklılık gösterebilir.
            </p>

            <div className="t-smartCalculation-choiceGroup">
                <label className="t-smartCalculation-choiceCard t-smartCalculation-choiceCard--arac" htmlFor="delivery-scope-arac">
                  <input
                    type="radio"
                    id="delivery-scope-arac"
                    name="deliveryOrgType"
                    value="1"
                    className="t-smartCalculation-choiceInput"
                    checked={selectedOrgTypeId === "1"}
                    onChange={(e) => this.setState({ selectedOrgTypeId: e.target.value })}
                  />
                  <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                    <i className="t-icon-truck1" />
                  </span>
                  <span className="t-smartCalculation-choiceLabel">Araç</span>
                  <span className="t-smartCalculation-choiceHint">Araç teslimatı</span>
                </label>
                <label className="t-smartCalculation-choiceCard t-smartCalculation-choiceCard--ev" htmlFor="delivery-scope-ev">
                  <input
                    type="radio"
                    id="delivery-scope-ev"
                    name="deliveryOrgType"
                    value="2"
                    className="t-smartCalculation-choiceInput"
                    checked={selectedOrgTypeId === "2"}
                    onChange={(e) => this.setState({ selectedOrgTypeId: e.target.value })}
                  />
                  <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                    <i className="t-icon-home1" />
                  </span>
                  <span className="t-smartCalculation-choiceLabel">Ev/İş Yeri</span>
                  <span className="t-smartCalculation-choiceHint">Konut veya iş yeri teslimatı</span>
                </label>
              </div>

            <div className="t-deliverySelectPanel-actions">
              {isChangingDeliveryScope && (
                <button
                  className="t-memberInfo-btn t-memberInfo-btn--secondary"
                  type="button"
                  onClick={this.cancelChangeDeliveryScope}
                >
                  Vazgeç
                </button>
              )}
              <button
                className="t-memberInfo-btn t-memberInfo-btn--primary"
                type="button"
                onClick={this.handleSaveDeliveryScopeClick}
              >
                Kaydet
                <i className="t-icon-arrow-right2" aria-hidden="true" />
              </button>
            </div>
          </div>
        </article>
      </>
    );
  };

  renderServiceRecordSelection = () => {
    const { deliveryDocuments, selectedServiceRecordId, isChangingServiceRecord } = this.state;
    const serviceOptions = [
      { value: "1", label: "4A", hint: "4A hizmet dökümü" },
      { value: "2", label: "4B", hint: "4B hizmet dökümü" },
      { value: "3", label: "4C", hint: "4C hizmet dökümü" },
    ];
    const selectedLabel = serviceOptions.find((item) => item.value === selectedServiceRecordId)?.label || "";

    return (
      <>
        {this.renderDeliveryStatusAlert(deliveryDocuments)}
        <article className="t-memberInfo-card t-deliverySelectCard t-memberDetail-header--green">
          <div className="t-memberInfo-cardInner">
            <div className="t-memberInfo-cardHeader">
              <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                <i className="t-icon-document-alt-stroke" aria-hidden="true" />
              </div>
              <div className="t-memberInfo-cardHeaderContent">
                <div className="t-memberInfo-cardTitleRow">
                  <h2 className="t-memberInfo-cardTitle">Hizmet Dökümü Seçimi</h2>
                  {selectedLabel && <span className="t-memberInfo-typeChip">{selectedLabel}</span>}
                </div>
                <div className="t-memberInfo-cardBadges">
                  <span className="t-memberDetail-headerBadge">Araç Teslimatı</span>
                </div>
              </div>
            </div>

            <p className="t-deliverySelectPanel-text">
              Araç teslimat dosyanızın doğru şekilde oluşturulabilmesi için hizmet dökümü türünü seçiniz.
              Seçiminize göre talep edilecek belge ve değerlendirme süreçleri farklılık gösterebilir.
            </p>

            <div className="t-smartCalculation-choiceGroup t-deliverySelectPanel-choices">
                {serviceOptions.map((item) => (
                  <label
                    key={item.value}
                    className="t-smartCalculation-choiceCard t-smartCalculation-choiceCard--ev"
                    htmlFor={`delivery-service-${item.value}`}
                  >
                    <input
                      type="radio"
                      id={`delivery-service-${item.value}`}
                      name="deliveryServiceRecord"
                      value={item.value}
                      className="t-smartCalculation-choiceInput"
                      checked={selectedServiceRecordId === item.value}
                      onChange={(e) => this.setState({ selectedServiceRecordId: e.target.value })}
                    />
                    <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                      <i className="t-icon-document-alt-stroke" />
                    </span>
                    <span className="t-smartCalculation-choiceLabel">{item.label}</span>
                    <span className="t-smartCalculation-choiceHint">{item.hint}</span>
                  </label>
                ))}
              </div>

            <div className="t-deliverySelectPanel-actions">
              {isChangingServiceRecord && (
                <button
                  className="t-memberInfo-btn t-memberInfo-btn--secondary"
                  type="button"
                  onClick={this.cancelChangeServiceRecord}
                >
                  Vazgeç
                </button>
              )}
              <button
                className="t-memberInfo-btn t-memberInfo-btn--primary"
                type="button"
                onClick={this.handleSaveServiceRecordClick}
              >
                Kaydet
                <i className="t-icon-arrow-right2" aria-hidden="true" />
              </button>
            </div>
          </div>
        </article>
      </>
    );
  };

  renderDeliveryDocumentsLoading = () => (
    <EminevimLoading
      compact
      subtext="Teslimat doküman bilgileriniz hazırlanıyor, lütfen bekleyiniz."
    />
  );

  renderDeliveryScopeSummaryCard = ({ themeClass, iconClass, label, value, canChange, onChange, actionLabel }) => (
    <article className={`t-memberInfo-card t-deliverySelectCard t-deliveryScopeCard ${themeClass}`}>
      <div className="t-deliveryScopeCard-inner">
        <div className="t-deliveryScopeCard-info">
          <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon t-deliveryScopeCard-icon">
            <i className={iconClass} aria-hidden="true" />
          </div>
          <div className="t-deliveryScopeCard-copy">
            <span className="t-deliveryScopeCard-label">{label}</span>
            <span className="t-memberInfo-typeChip">{value}</span>
          </div>
        </div>
        {canChange && (
          <button
            className="t-memberInfo-btn t-memberInfo-btn--secondary t-deliveryScopeCard-action"
            type="button"
            onClick={onChange}
          >
            {actionLabel}
          </button>
        )}
      </div>
    </article>
  );

  renderDeliveryDocumentsContent = () => {
    const { deliveryDocuments, deliveryDocumentsLoading, guarantors, guarantorsLoading, isChangingDeliveryScope, isChangingServiceRecord } = this.state;

    if (isChangingDeliveryScope) {
      return this.renderDeliveryScopeSelection();
    }

    if (isChangingServiceRecord) {
      return this.renderServiceRecordSelection();
    }

    return (
      <>
        {this.renderDeliveryStatusAlert(deliveryDocuments)}

        {deliveryDocuments?.secilenOrgAdi && (
          <div className="t-deliveryScopeSummary">
            {this.renderDeliveryScopeSummaryCard({
              themeClass: deliveryDocuments.secilenOrgId === 1 ? "t-memberDetail-header--blue" : "t-memberDetail-header--green",
              iconClass: deliveryDocuments.secilenOrgId === 1 ? "t-icon-truck1" : "t-icon-home1",
              label: "Seçilen Teslimat Kapsamı",
              value: deliveryDocuments.secilenOrgAdi,
              canChange: deliveryDocuments?.teslimatKapsamiDegistirebilirMi,
              onChange: this.openChangeDeliveryScope,
              actionLabel: "Teslimat Kapsamını Değiştir",
            })}

            {deliveryDocuments?.secilenOrgId === 1 && deliveryDocuments?.secilenHizmetTurAdi && (
              this.renderDeliveryScopeSummaryCard({
                themeClass: "t-memberDetail-header--green",
                iconClass: "t-icon-document-alt-stroke",
                label: "Seçilen Hizmet Dökümü Türü",
                value: deliveryDocuments.secilenHizmetTurAdi,
                canChange: deliveryDocuments?.hizmetTuruDegistirebilirMi,
                onChange: this.openChangeServiceRecord,
                actionLabel: "Hizmet Dökümü Türünü Değiştir",
              })
            )}
          </div>
        )}

        {this.state.isShowGuarantors && (
          <>
            <div
              role="button"
              tabIndex={0}
              className="t-guarantorAddBox"
              onClick={this.openAddGuarantorModal}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  this.openAddGuarantorModal();
                }
              }}
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  backgroundColor: "#e8f5e9",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "12px",
                }}
              >
                <i className="t-icon-user-plus" style={{ fontSize: "28px", color: "#0c9908" }} />
              </div>
              <div
                style={{
                  fontSize: "14pt",
                  fontWeight: "bold",
                  color: "#0c9908",
                  letterSpacing: "0.5px",
                  marginBottom: "8px",
                }}
              >
                KEFİL EKLE
              </div>
              <div style={{ fontSize: "11pt", color: "#6b7a90" }}>
                Kefil bilgilerini ekleyerek zorunlu dokümanları yüklemeye başlayın.
              </div>
            </div>

            <div className="t-deliverySectionCard">
              <div className="t-deliverySectionCard-header">
                <strong className="t-deliverySectionTitle">Kefil Listesi</strong>
                {guarantors?.length > 0 && (
                  <span className="t-deliverySectionCount">{guarantors.length} kayıt</span>
                )}
              </div>

              {guarantorsLoading ? (
                <EminevimLoading
                  compact
                  className="t-deliverySectionCard-loading"
                  subtext="Kefil listesi yükleniyor, lütfen bekleyiniz."
                />
              ) : (
              <div className="t-deliveryDataTableWrap">
              <table className="t-deliveryDataTable t-guarantorList-table">
                <thead>
                  <tr>
                    <th scope="col">Ad Soyad</th>
                    <th scope="col">TC No</th>
                    <th scope="col">Telefon</th>
                    <th scope="col">Doğum Tarihi</th>
                    <th scope="col" className="t-deliveryDataTable-actions">İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {guarantors && guarantors.length > 0 ? guarantors.map((item, index) => (
                    <tr key={item.id || item.tckn || index}>
                      <td data-label="Ad Soyad" className="t-deliveryDataTable-primary">{item.adSoyad}</td>
                      <td data-label="TC No">{item.tckn}</td>
                      <td data-label="Telefon">{this.formatPhone(item.gsm)}</td>
                      <td data-label="Doğum Tarihi">{item.dogumTarihi ? new Date(item.dogumTarihi).toLocaleDateString("tr-TR") : "-"}</td>
                      <td data-label="İşlem" className="t-deliveryDataTable-actions t-guarantorList-action">
                        {item.isDeleted === true ? (
                          <span className="t-salesDocStatus t-salesDocStatus--review">Silme onayı bekliyor</span>
                        ) : (
                          <button
                            className="t-deliveryDocAction t-deliveryDocAction--delete"
                            type="button"
                            onClick={() => this.deleteGuarantor(item.id)}
                          >
                            <i className="t-icon-trash1" aria-hidden="true" />
                            Sil
                          </button>
                        )}
                      </td>
                    </tr>
                  )) : (
                    <tr className="t-deliveryDataTable-empty">
                      <td colSpan={5}>Kefil kaydı bulunmuyor.</td>
                    </tr>
                  )}
                </tbody>
              </table>
              </div>
              )}
            </div>
          </>
        )}

        <div className="t-deliverySectionCard">
          <div className="t-deliverySectionCard-header">
            <strong className="t-deliverySectionTitle">Dokümanlar</strong>
            {deliveryDocuments?.dokumanlar?.length > 0 && (
              <span className="t-deliverySectionCount">{deliveryDocuments.dokumanlar.length} kayıt</span>
            )}
          </div>

          {deliveryDocumentsLoading ? (
            <EminevimLoading
              compact
              className="t-deliverySectionCard-loading"
              subtext="Dokümanlar yükleniyor, lütfen bekleyiniz."
            />
          ) : (
          <div className="t-deliveryDataTableWrap">
          <table className="t-deliveryDataTable t-deliveryDocuments-table">
            <thead>
              <tr>
                <th scope="col">Doküman</th>
                <th scope="col">Durum</th>
                <th scope="col" className="t-deliveryDataTable-actions">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {deliveryDocuments?.dokumanlar && deliveryDocuments.dokumanlar.length > 0 ? (
                deliveryDocuments.dokumanlar.map((item, index) => {
                  const canChange = item.id > 0 && item.mobilDokumanHash != null;
                  return (
                    <tr key={index}>
                      <td data-label="Doküman" className="t-deliveryDataTable-primary">
                        <span className="t-deliveryDocName">
                          <span
                            className={`t-deliveryDocRequired${item.isForced ? "" : " is-empty"}`}
                            title={item.isForced ? "Zorunlu" : undefined}
                          >
                            Zorunlu
                          </span>
                          <span className="t-deliveryDocName-copy">
                            <span>{item.mobilDokumanAdi}</span>
                            {item.sablonRaporId != null && item.sablonRaporId != 0 && (
                              <button
                                type="button"
                                className="t-deliveryDocTemplate"
                                onClick={() => this.downloadReportFile(item.sablonRaporId, "Muvafakatname.pdf")}
                              >
                                Şablon İndir
                              </button>
                            )}
                          </span>
                        </span>
                      </td>
                      <td data-label="Durum">
                        {this.renderDeliveryDocumentStatus(item)}
                      </td>
                      <td data-label="İşlemler" className="t-deliveryDataTable-actions">
                        <input
                          type="file"
                          ref={this.fileInputRef}
                          style={{ display: "none" }}
                          accept="application/pdf,image/*"
                          onChange={this.handleFileChange}
                        />
                        <div
                          className={`t-deliveryDocActions${
                            item.isShowUpload === true && item.isShowDownload === true
                              ? " t-deliveryDocActions--group"
                              : ""
                          }`}
                        >
                          {item.isShowUpload === true && (
                            <button
                              type="button"
                              className={`t-deliveryDocAction ${
                                canChange ? "t-deliveryDocAction--change" : "t-deliveryDocAction--upload"
                              }`}
                              onClick={(e) => this.handleUploadClick(item.mobilDokumanTurId, e)}
                            >
                              <i
                                className={canChange ? "t-icon-pencil" : "t-icon-file_upload"}
                                aria-hidden="true"
                              />
                              {canChange ? "Değiştir" : "Yükle"}
                            </button>
                          )}
                          {item.isShowDownload === true && (
                            <button
                              type="button"
                              className="t-deliveryDocAction t-deliveryDocAction--download"
                              onClick={() => this.downloadCdnFile(item.id, item.mobilDokumanDosyaAdi)}
                            >
                              <i className="t-icon-folder-download" aria-hidden="true" />
                              İndir
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="t-deliveryDataTable-empty">
                  <td colSpan={3}>Doküman kaydı bulunmuyor.</td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
          )}
        </div>
        <div className="t-deliveryDocuments-submit">
          <button className="t-memberInfo-btn t-memberInfo-btn--primary" onClick={this.sendDocumentsForReview} type="button">
            İncelemeye Gönder
            <i className="t-icon-arrow-right2" aria-hidden="true" />
          </button>
        </div>
      </>
    );
  };

  getEmptyGuarantorForm = () => ({
    adi: "",
    soyadi: "",
    vatandaslikNo: "",
    gsm: "",
    dogumTarihi: "",
    kartId: 0
  });

  mapOfficerToGuarantorPayload = (officer) => {
    const adi = (officer?.adi || officer?.Adi || "").trim();
    const soyadi = (officer?.soyadi || officer?.Soyadi || "").trim();
    const vatandaslikNo = String(officer?.tcNo || officer?.TCNo || "").replace(/\D/g, "").slice(0, 11);
    const gsm = this.normalizePhone(officer?.telefon || officer?.Telefon || "");
    const displayDate = this.convertIsoToDisplayDate(officer?.dogumTarihi || officer?.DogumTarihi);
    const dogumTarihi = this.convertDisplayDateToIso(displayDate);

    return {
      adi,
      soyadi,
      vatandaslikNo,
      gsm,
      dogumTarihi,
      displayDate,
      kartYetkiliId: officer?.kartId || officer?.KartId || null,
      fullName: `${adi} ${soyadi}`.trim()
    };
  };

  openAddGuarantorModal = () => {
    this.setState({ showGuarantorCriteriaWarningModal: true });
  };

  closeGuarantorCriteriaWarningModal = () => {
    this.setState({ showGuarantorCriteriaWarningModal: false });
  };

  confirmGuarantorCriteriaWarning = () => {
    this.setState({ showGuarantorCriteriaWarningModal: false }, () => {
      this.continueAddGuarantorFlow();
    });
  };

  continueAddGuarantorFlow = () => {
    if (this.isCorporateCard()) {
      this.setState({
        showGuarantorChoiceModal: true,
        showAddGuarantorModal: false,
        showCorporateOfficerModal: false,
        showOfficerGuarantorConfirmModal: false,
        pendingOfficerGuarantor: null,
        isCorporateOfficerSelected: false,
        guarantorForm: this.getEmptyGuarantorForm()
      });
      return;
    }

    this.openManualGuarantorForm();
  };

  closeGuarantorChoiceModal = () => {
    this.setState({ showGuarantorChoiceModal: false });
  };

  openManualGuarantorForm = () => {
    this.setState({
      showGuarantorChoiceModal: false,
      showAddGuarantorModal: true,
      showCorporateOfficerModal: false,
      corporateOfficers: [],
      isCorporateOfficerSelected: false,
      guarantorForm: this.getEmptyGuarantorForm()
    });
  };

  closeAddGuarantorModal = () => {
    this.setState({
      showAddGuarantorModal: false,
      showGuarantorChoiceModal: false,
      showCorporateOfficerModal: false,
      showOfficerGuarantorConfirmModal: false,
      corporateOfficers: [],
      pendingOfficerGuarantor: null,
      isCorporateOfficerSelected: false
    });
  };

  openCorporateOfficerModal = () => {
    const { match } = this.props;
    const memberId = match?.params?.id;
    if (!memberId) {
      toast.error("Üyelik bilgisi bulunamadı");
      return;
    }

    const requestId = (this._corporateOfficersRequestId || 0) + 1;
    this._corporateOfficersRequestId = requestId;

    this.setState({
      showGuarantorChoiceModal: false,
      showCorporateOfficerModal: true,
      corporateOfficersLoading: true,
      corporateOfficers: []
    });

    getCorporateCardOfficerService(memberId)
      .then((result) => {
        if (this._corporateOfficersRequestId !== requestId) return;

        const parsedResult = this.parseApiResult(result);
        const officers = parsedResult?.data || [];

        if (!parsedResult?.success) {
          this.setState({
            corporateOfficersLoading: false,
            showCorporateOfficerModal: false,
            showGuarantorChoiceModal: true
          });
          toast.error(parsedResult?.message || "Kart yetkilileri listelenemedi");
          return;
        }

        if (!officers.length) {
          this.setState({
            corporateOfficersLoading: false,
            showCorporateOfficerModal: false,
            showGuarantorChoiceModal: true
          });
          toast.error("Bu karta ait kart yetkilisi bulunmamaktadır. Müşteri temsilciniz ile iletişime geçiniz.");
          return;
        }

        this.setState({
          corporateOfficersLoading: false,
          corporateOfficers: officers
        });
      })
      .catch(() => {
        if (this._corporateOfficersRequestId !== requestId) return;
        this.setState({
          corporateOfficersLoading: false,
          showCorporateOfficerModal: false,
          showGuarantorChoiceModal: true
        });
        toast.error("Kart yetkilileri listelenemedi");
      });
  };

  closeCorporateOfficerModal = () => {
    this._corporateOfficersRequestId = (this._corporateOfficersRequestId || 0) + 1;
    this.setState({
      showCorporateOfficerModal: false,
      corporateOfficersLoading: false,
      showGuarantorChoiceModal: this.isCorporateCard() && !this.state.showAddGuarantorModal
    });
  };

  selectCorporateOfficer = (officer) => {
    if (!officer) return;
    if (officer.kefilEklenmisMi === true || officer.KefilEklenmisMi === true) return;

    this.setState({
      showCorporateOfficerModal: false,
      showOfficerGuarantorConfirmModal: true,
      pendingOfficerGuarantor: officer
    });
  };

  closeOfficerGuarantorConfirmModal = () => {
    this.setState({
      showOfficerGuarantorConfirmModal: false,
      pendingOfficerGuarantor: null,
      showCorporateOfficerModal: true
    });
  };

  confirmOfficerAsGuarantor = () => {
    const payload = this.mapOfficerToGuarantorPayload(this.state.pendingOfficerGuarantor);
    const started = this.submitGuarantor({
      ...payload,
      kartYetkiliId: payload.kartYetkiliId
    });

    if (started) {
      this.setState({
        showOfficerGuarantorConfirmModal: false,
        showCorporateOfficerModal: false
      });
    }
  };

  clearCorporateOfficerSelection = () => {
    this.setState({
      isCorporateOfficerSelected: false,
      guarantorForm: this.getEmptyGuarantorForm()
    });
  };

  closeDeleteGuarantorModal = () => {
    this.setState({
      showDeleteGuarantorModal: false,
      selectedGuarantorId: null
    });
  };

  handleGuarantorInputChange = (field, value) => {
    if (this.state.isCorporateOfficerSelected) return;

    this.setState((prevState) => ({
      guarantorForm: {
        ...prevState.guarantorForm,
        [field]: value
      }
    }));
  };

  addGuarantor = () => {
    const { guarantorForm } = this.state;
    this.submitGuarantor({
      adi: guarantorForm.adi?.trim(),
      soyadi: guarantorForm.soyadi?.trim(),
      vatandaslikNo: guarantorForm.vatandaslikNo?.replace(/\D/g, ""),
      gsm: this.normalizePhone(guarantorForm.gsm),
      dogumTarihi: this.convertDisplayDateToIso(guarantorForm.dogumTarihi),
      displayDate: guarantorForm.dogumTarihi,
      kartYetkiliId: null
    });
  };

  submitGuarantor = ({ adi, soyadi, vatandaslikNo, gsm, dogumTarihi, displayDate, kartYetkiliId = null }) => {
    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;

    if (!adi || !soyadi || !vatandaslikNo || !gsm || !displayDate) {
      toast.error("Lütfen tüm alanları doldurun");
      return;
    }

    if (!dogumTarihi) {
      toast.error("Doğum tarihi formatı gg/aa/yyyy olmalıdır");
      return;
    }

    if (this.isFutureDisplayDate(displayDate)) {
      toast.error("Doğum tarihi bugünden büyük olamaz");
      return;
    }

    if (vatandaslikNo.length !== 11) {
      toast.error("TC No 11 haneli olmalıdır");
      return;
    }

    if (!gsm.startsWith("5")) {
      toast.error("Telefon numarası 5 ile başlamalı ve başında 0 olmamalıdır");
      return;
    }

    if (gsm.length !== 10) {
      toast.error("Telefon numarası 10 haneli olmamalıdır");
      return false;
    }

    this.showPageLoading();

    addGuarantorService({
      kartId: 0,
      kartYetkiliId: kartYetkiliId || null,
      uyelikId,
      adi,
      soyadi,
      vatandaslikNo,
      gsm,
      dogumTarihi
    }).then((result) => {
      const parsedResult = this.parseApiResult(result);
      this.hidePageLoading();

      if (parsedResult?.success) {
        this.closeAddGuarantorModal();
        this.loadDeliveryDocuments(uyelikId);
        toast.success("Kefil kaydedildi");
      } else {
        toast.error(parsedResult?.message || "Kefil kaydedilemedi");
      }
    }).catch(() => {
      this.hidePageLoading();
      toast.error("Kefil kaydedilemedi");
    });

    return true;
  };

  deleteGuarantor = (guarantorId) => {
    if (!guarantorId) {
      toast.error("Silme işlemi için kefil kimliği bulunamadı");
      return;
    }

    this.setState({
      showDeleteGuarantorModal: true,
      selectedGuarantorId: guarantorId
    });
  };

  confirmDeleteGuarantor = () => {
    const { selectedGuarantorId } = this.state;

    if (!selectedGuarantorId) {
      this.closeDeleteGuarantorModal();
      toast.error("Silme işlemi için kefil kimliği bulunamadı");
      return;
    }

    this.closeDeleteGuarantorModal();

    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;

    this.showPageLoading();
    deleteGuarantorService({
      kartId: 0,
      uyelikId,
      id: selectedGuarantorId
    }).then((result) => {
      const parsedResult = this.parseApiResult(result);
      this.hidePageLoading();
      if (parsedResult?.success) {
        this.loadDeliveryDocuments(uyelikId);
        toast.success("Kefil silme işleminiz onaya gönderildi.");
      } else {
        toast.error(parsedResult?.message || "Kefil silinemedi");
      }
    }).catch(() => {
      this.hidePageLoading();
      toast.error("Kefil silinemedi");
    });
  };

  sendDocumentsForReview = () => {
    this.showPageLoading("Dokümanlarınız incelemeye gönderiliyor, lütfen bekleyiniz.");
    const { match } = this.props;
    var memberId = Number(match?.params?.id) ?? 0;

    // const formData = new FormData();
    // formData.append("MemberId", memberId);
    var data = {
      "cardId": 0,
      memberId
    };
    sendDocumentsForReviewService(data).then((result) => {
      this.hidePageLoading();
      if (result.success) {
        this.loadDeliveryDocuments(memberId);
        toast.success("Dosyalar incelemeye gönderildi");

      } else {
        toast.error(result.message);
      }
    });
  }

  setDrawId = (drawId, cekilisTarihi) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getDrawDetail(id, drawId);
    this.setState({ cekilisTarihi: cekilisTarihi });
  };

  getFreezeDetail = (source) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getFreezeDetail(id, source);
  };

  getDocumentFile = (documentId, documentName) => {
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.getDocumentFile(documentId, ext, documentName);
  };

  downloadCdnFile = (id, documentName) => {
    const { match } = this.props;
    var memberId = match?.params?.id;
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.downloadCdnFile(id, memberId, ext, documentName);
  };

  downloadReportFile = (raporId, documentName) => {
    const { match } = this.props;
    var memberId = match?.params?.id;
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.downloadReportFile(memberId, raporId, ext, documentName);
  };

  getAcceptTypes = (documentTypes) => {
    const map = {
      pdf: "application/pdf",
      image: "image/*"
    };

    return documentTypes
      ?.map(type => map[type])
      .filter(Boolean)
      .join(",");
  };

  getMemberHeaderThemeClass = () => {
    const { orgTurId } = this.state.uye;

    if (orgTurId === 2) return "t-memberDetail-header--green";
    if (orgTurId === 3) return "t-memberDetail-header--orange";
    if (orgTurId === 1) return "t-memberDetail-header--blue";
    return "t-memberDetail-header--blue";
  };

  renderMemberHeaderIcon = () => {
    const { orgTurId } = this.state.uye;

    if (orgTurId === 2) {
      return <i className="t-icon-home1" aria-hidden="true" />;
    }

    if (orgTurId === 3) {
      return (
        <img
          src="/assets/img/svg/icon_kabe.svg"
          alt=""
          className="t-memberDetail-headerKabeIcon"
        />
      );
    }

    if (orgTurId === 1) {
      return <i className="t-icon-truck1" aria-hidden="true" />;
    }

    return null;
  };

  renderMemberDetailLoading = () => (
    <EminevimLoading
      compact
      className="t-memberDetailTabsLoading"
      subtext="Üyelik içerikleri hazırlanıyor, lütfen bekleyiniz."
    />
  );

  renderPageLoadingOverlay = () => {
    if (!this.state.isShowLoading) return null;

    return (
      <div className="t-memberDetail-processingOverlay">
        <EminevimLoading subtext={this.state.loadingSubtext} />
      </div>
    );
  };

  renderMemberHeader = () => {
    const { uye } = this.state;
    const showPlannedDeliveryDate = uye.kayitTuruId !== 10 && uye.kayitTuruId !== 11;

    return (
      <div className={`t-memberDetail-header ${this.getMemberHeaderThemeClass()}`}>
        <div className="t-memberDetail-headerMain">
          <Link
            to="/Home/MemberInfo"
            className="t-memberDetail-headerBack"
            title="Üyelik Listesine Dön"
            aria-label="Üyelik Listesine Dön"
          >
            <i className="t-icon-arrow-left2" aria-hidden="true" />
          </Link>

          <div className="t-memberDetail-headerIcon">
            {this.renderMemberHeaderIcon()}
          </div>

          <div className="t-memberDetail-headerContent">
            <h1 className="t-memberDetail-headerTitle">{uye.orgSis}</h1>
            <div className="t-memberDetail-headerBadges">
              <span className="t-memberDetail-headerBadge">
                Üye No :&nbsp;
                <NumberFormat
                  decimalSeparator={false}
                  thousandSeparator={"."}
                  value={uye.uyeNo}
                  displayType={"text"}
                />
              </span>
              <span className="t-memberDetail-headerBadge">
                {showPlannedDeliveryDate ? "Planlanan Teslimat Tarihi" : "Teslimat Tarihi"} : &nbsp;{uye.teslimTarihi}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getDeliveryDocumentStatusClass = (item) => {
    const durum = Number(item?.musteriDokumanDurum);
    if (durum === 4) return "t-salesDocStatus--success";
    if (durum === 1) return "t-salesDocStatus--waiting";
    if (durum === 2 || durum === 5) return "t-salesDocStatus--error";
    if (durum === 0 || durum === 3) return "t-salesDocStatus--review";

    const text = (item?.musteriDokumanDurumText || "").toLocaleLowerCase("tr-TR");
    if (text.includes("başar")) return "t-salesDocStatus--success";
    if (text.includes("yüklenmedi") || text.includes("incelen")) return "t-salesDocStatus--review";
    if (text.includes("yüklendi")) return "t-salesDocStatus--waiting";
    if (text.includes("hatal")) return "t-salesDocStatus--error";
    return "t-salesDocStatus--default";
  };

  renderDeliveryDocumentStatus = (item) => {
    const statusText = item?.musteriDokumanDurumText;
    if (!statusText) return "-";

    const showErrorInfo = Number(item.musteriDokumanDurum) === 2 && item.aciklama?.trim();

    return (
      <span className="t-deliveryDocStatus">
        <span className={`t-salesDocStatus ${this.getDeliveryDocumentStatusClass(item)}`}>
          {statusText}
        </span>
        {showErrorInfo ? (
          <i
            className="fa fa-info-circle t-deliveryDocStatus-info"
            aria-hidden="true"
            data-toggle="tooltip"
            data-placement="right"
            title={item.aciklama}
          />
        ) : null}
      </span>
    );
  };

  renderDeliveryScopeConfirmModal = () => {
    const { showDeliveryScopeConfirmModal } = this.state;

    if (!showDeliveryScopeConfirmModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorModal t-guarantorFormModal t-deliveryConfirmModal" style={{ display: "block", zIndex: 1004 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content t-guarantorModal-content t-guarantorFormModal-content border-0">
              <div className="t-guarantorModal-header t-guarantorFormModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon t-guarantorFormModal-icon t-deliveryConfirm-icon">
                    <i className="t-icon-warning" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title">Onay</h5>
                    <p className="t-guarantorModal-subtitle">Teslimat kapsamı değişikliği</p>
                  </div>
                </div>
                <button type="button" className="t-guarantorFormModal-close" onClick={this.closeDeliveryScopeConfirmModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="t-guarantorModal-confirmBody">
                <div className="t-deliveryConfirm-warning">
                  <p>Teslimat kapsamı değişikliği yaptığınızda şu ana kadar yüklenen dokümanlarınız ve kefil bilgileriniz silinecektir!</p>
                </div>
              </div>
              <div className="t-guarantorModal-footer t-guarantorFormModal-footer">
                <button
                  type="button"
                  className="t-guarantorModal-cancel"
                  onClick={this.closeDeliveryScopeConfirmModal}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  className="t-guarantorModal-deleteBtn"
                  onClick={this.confirmSaveDeliveryScopeSelection}
                >
                  Evet, Onaylıyorum
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1003 }}></div>
      </>,
      document.body
    );
  };

  renderDeleteGuarantorModal = () => {
    const { showDeleteGuarantorModal } = this.state;

    if (!showDeleteGuarantorModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorChoiceModal t-guarantorDeleteModal" style={{ display: "block", zIndex: 1002 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content t-guarantorChoiceModal-content border-0">
              <button type="button" className="t-guarantorChoiceModal-close" onClick={this.closeDeleteGuarantorModal}>
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="t-guarantorChoiceModal-header">
                <div className="t-guarantorChoiceModal-icon">
                  <i className="t-icon-trash1" aria-hidden="true" />
                </div>
                <h5 className="t-guarantorChoiceModal-title">Silme Onayı</h5>
                <p className="t-guarantorChoiceModal-subtitle">Kefil kaydı silme işlemi onaya gönderilecektir.</p>
              </div>
              <div className="t-guarantorCriteriaModal-body">
                <div className="t-guarantorCriteriaModal-card t-guarantorDeleteModal-card">
                  <p>Kefil bilgilerini silme onayına göndermeyi onaylıyor musunuz?</p>
                </div>
                <div className="t-guarantorDeleteModal-actions">
                  <button
                    type="button"
                    className="t-guarantorModal-cancel"
                    onClick={this.closeDeleteGuarantorModal}
                  >
                    Vazgeç
                  </button>
                  <button
                    type="button"
                    className="t-guarantorDeleteModal-action"
                    onClick={this.confirmDeleteGuarantor}
                  >
                    Evet, Gönder
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1001 }}></div>
      </>,
      document.body
    );
  };

  renderGuarantorCriteriaWarningModal = () => {
    const { showGuarantorCriteriaWarningModal } = this.state;

    if (!showGuarantorCriteriaWarningModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorChoiceModal t-guarantorCriteriaModal" style={{ display: "block", zIndex: 1002 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content t-guarantorChoiceModal-content border-0">
              <button type="button" className="t-guarantorChoiceModal-close" onClick={this.closeGuarantorCriteriaWarningModal}>
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="t-guarantorChoiceModal-header">
                <div className="t-guarantorChoiceModal-icon">
                  <i className="t-icon-info_outline" aria-hidden="true" />
                </div>
                <h5 className="t-guarantorChoiceModal-title">Bilgilendirme</h5>
                <p className="t-guarantorChoiceModal-subtitle">Kefil ekleme kriterlerini inceleyiniz.</p>
              </div>
              <div className="t-guarantorCriteriaModal-body">
                <div className="t-guarantorCriteriaModal-card">
                  <span className="t-guarantorCriteriaModal-step">1</span>
                  <p>Kefil olarak eklenecek kişinin aktif olarak çalışıyor ve belgelenebilir düzenli gelire sahip olması gerekmektedir.</p>
                </div>
                <div className="t-guarantorCriteriaModal-card">
                  <span className="t-guarantorCriteriaModal-step">2</span>
                  <p>Emekli, çalışmayan veya işten ayrılmış kişiler kefil olarak kabul edilmemektedir. Uygun kriterleri taşımayan kefil eklenmesi, teslimat sürecinizin iptal edilmesine veya uzamasına neden olabilir.</p>
                </div>
                <div className="t-guarantorCriteriaModal-card">
                  <span className="t-guarantorCriteriaModal-step">3</span>
                  <p>Lütfen kefil bilgilerini bu kriterlere uygun şekilde giriniz.</p>
                </div>
                <button
                  type="button"
                  className="t-guarantorCriteriaModal-action"
                  onClick={this.confirmGuarantorCriteriaWarning}
                >
                  Anladım
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1001 }}></div>
      </>,
      document.body
    );
  };

  renderOfficerGuarantorConfirmModal = () => {
    const { showOfficerGuarantorConfirmModal, pendingOfficerGuarantor } = this.state;

    if (!showOfficerGuarantorConfirmModal || !pendingOfficerGuarantor) return null;

    const payload = this.mapOfficerToGuarantorPayload(pendingOfficerGuarantor);
    const fullName = payload.fullName || "Seçilen kişi";

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorModal" style={{ display: "block", zIndex: 1200 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content t-guarantorModal-content border-0">
              <div className="t-guarantorModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon">
                    <i className="t-icon-user-plus" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title">Kefil Onayı</h5>
                    <p className="t-guarantorModal-subtitle">Kart yetkilisi kefil olarak eklenecektir.</p>
                  </div>
                </div>
                <button type="button" className="t-guarantorModal-close" onClick={this.closeOfficerGuarantorConfirmModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="t-guarantorModal-confirmBody">
                <p>
                  <strong>{fullName}</strong> kişisi kefil olarak eklenecektir. Onaylıyor musunuz?
                </p>
              </div>
              <div className="t-guarantorModal-footer">
                <button
                  type="button"
                  className="t-guarantorModal-cancel"
                  onClick={this.closeOfficerGuarantorConfirmModal}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  className="t-icButtonYesil"
                  onClick={this.confirmOfficerAsGuarantor}
                >
                  <span>Evet, Onaylıyorum</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1199 }}></div>
      </>,
      document.body
    );
  };

  renderGuarantorChoiceModal = () => {
    const { showGuarantorChoiceModal } = this.state;

    if (!showGuarantorChoiceModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorChoiceModal" style={{ display: "block", zIndex: 1000 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content t-guarantorChoiceModal-content border-0">
              <button type="button" className="t-guarantorChoiceModal-close" onClick={this.closeGuarantorChoiceModal}>
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="t-guarantorChoiceModal-header">
                <div className="t-guarantorChoiceModal-icon">
                  <i className="t-icon-user-plus" aria-hidden="true" />
                </div>
                <h5 className="t-guarantorChoiceModal-title">Kefil Ekle</h5>
                <p className="t-guarantorChoiceModal-subtitle">Kefil bilgilerini nasıl eklemek istediğinizi seçin.</p>
              </div>
              <div className="t-guarantorChoiceModal-body">
                <button
                  type="button"
                  className="t-guarantorChoiceOption"
                  onClick={this.openCorporateOfficerModal}
                >
                  <span className="t-guarantorChoiceOption-icon">
                    <i className="t-icon-credit-card" aria-hidden="true" />
                  </span>
                  <span className="t-guarantorChoiceOption-copy">
                    <span className="t-guarantorChoiceOption-text">Kart Yetkililerinden Seçim Yap</span>
                    <span className="t-guarantorChoiceOption-hint">Kartınızda tanımlı yetkililerden seçin</span>
                  </span>
                  <span className="t-guarantorChoiceOption-arrowWrap">
                    <i className="t-icon-arrow-right2 t-guarantorChoiceOption-arrow" aria-hidden="true" />
                  </span>
                </button>
                <button
                  type="button"
                  className="t-guarantorChoiceOption"
                  onClick={this.openManualGuarantorForm}
                >
                  <span className="t-guarantorChoiceOption-icon">
                    <i className="t-icon-user-plus" aria-hidden="true" />
                  </span>
                  <span className="t-guarantorChoiceOption-copy">
                    <span className="t-guarantorChoiceOption-text">Yeni Bilgilerle Giriş Yap</span>
                    <span className="t-guarantorChoiceOption-hint">Kefil bilgilerini kendiniz girin</span>
                  </span>
                  <span className="t-guarantorChoiceOption-arrowWrap">
                    <i className="t-icon-arrow-right2 t-guarantorChoiceOption-arrow" aria-hidden="true" />
                  </span>
                </button>
                <div className="t-guarantorChoiceInfo">
                  <span className="t-guarantorChoiceInfo-icon">
                    <i className="t-icon-info_outline" aria-hidden="true" />
                  </span>
                  <p>
                    Kurum kartlarında eklenecek kefillerden en az bir tanesi kartınızda tanımlı ‘Kart Yetkilisi’ olmalıdır.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 999 }}></div>
      </>,
      document.body
    );
  };

  renderAddGuarantorModal = () => {
    const { showAddGuarantorModal, guarantorForm, isCorporateOfficerSelected } = this.state;
    const isOfficerLocked = isCorporateOfficerSelected;

    if (!showAddGuarantorModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorModal t-guarantorFormModal" style={{ display: "block", zIndex: 1000 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content t-guarantorModal-content t-guarantorFormModal-content border-0">
              <div className="t-guarantorModal-header t-guarantorFormModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon t-guarantorFormModal-icon">
                    <i className="t-icon-user-plus" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title">Kefil Ekle</h5>
                    <p className="t-guarantorModal-subtitle">Kefil bilgilerini eksiksiz doldurunuz.</p>
                  </div>
                </div>
                <button type="button" className="t-guarantorFormModal-close" onClick={this.closeAddGuarantorModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="t-guarantorModal-body t-guarantorFormModal-body">
                {isOfficerLocked && (
                  <div className="t-guarantorModal-officerAction">
                    <button
                      type="button"
                      className="t-guarantorModal-clear"
                      onClick={this.clearCorporateOfficerSelection}
                    >
                      Temizle
                    </button>
                  </div>
                )}
                <label className="t-guarantorForm-field">
                  <span className="t-guarantorForm-label">Adı</span>
                  <div className={`t-icInput${isOfficerLocked ? " t-icInput--readonly" : ""}`}>
                    <div>
                      <i className="t-icon-user1" />
                    </div>
                    <input
                      value={guarantorForm.adi}
                      placeholder="Adı"
                      readOnly={isOfficerLocked}
                      onChange={(e) => this.handleGuarantorInputChange("adi", e.target.value)}
                    />
                    <div />
                  </div>
                </label>

                <label className="t-guarantorForm-field">
                  <span className="t-guarantorForm-label">Soyadı</span>
                  <div className={`t-icInput${isOfficerLocked ? " t-icInput--readonly" : ""}`}>
                    <div>
                      <i className="t-icon-user1" />
                    </div>
                    <input
                      value={guarantorForm.soyadi}
                      placeholder="Soyadı"
                      readOnly={isOfficerLocked}
                      onChange={(e) => this.handleGuarantorInputChange("soyadi", e.target.value)}
                    />
                    <div />
                  </div>
                </label>

                <label className="t-guarantorForm-field">
                  <span className="t-guarantorForm-label">TC No</span>
                  <div className={`t-icInput${isOfficerLocked ? " t-icInput--readonly" : ""}`}>
                    <div>
                      <i className="t-icon-user1" />
                    </div>
                    <input
                      value={guarantorForm.vatandaslikNo}
                      maxLength={11}
                      placeholder="11 haneli TC No"
                      readOnly={isOfficerLocked}
                      onChange={(e) => this.handleGuarantorInputChange("vatandaslikNo", e.target.value.replace(/\D/g, ""))}
                    />
                    <div />
                  </div>
                </label>

                <label className="t-guarantorForm-field">
                  <span className="t-guarantorForm-label">Telefon</span>
                  <div className={`t-icInput${isOfficerLocked ? " t-icInput--readonly" : ""}`}>
                    <div>
                      <i className="t-icon-phone1" />
                    </div>
                    <input
                      value={this.formatPhone(guarantorForm.gsm)}
                      maxLength={13}
                      placeholder="5XX XXX XX XX"
                      readOnly={isOfficerLocked}
                      onChange={(e) => this.handleGuarantorInputChange("gsm", e.target.value)}
                    />
                    <div />
                  </div>
                </label>

                <label className="t-guarantorForm-field">
                  <span className="t-guarantorForm-label">Doğum Tarihi</span>
                  <div className={`t-icInput${isOfficerLocked ? " t-icInput--readonly" : ""}`}>
                    <div>
                      <i className="t-icon-calendar1" />
                    </div>
                    <input
                      type="text"
                      inputMode="numeric"
                      maxLength={10}
                      placeholder="gg/aa/yyyy"
                      value={guarantorForm.dogumTarihi}
                      readOnly={isOfficerLocked}
                      onChange={(e) => {
                        const formattedValue = this.formatDateInput(e.target.value);
                        if (formattedValue.length === 10 && this.isFutureDisplayDate(formattedValue)) {
                          return;
                        }
                        this.handleGuarantorInputChange("dogumTarihi", formattedValue);
                      }}
                    />
                    <div />
                  </div>
                </label>
              </div>
              <div className="t-guarantorModal-footer t-guarantorFormModal-footer">
                <button
                  type="button"
                  className="t-guarantorModal-cancel"
                  onClick={this.closeAddGuarantorModal}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  className="t-guarantorFormModal-save"
                  onClick={this.addGuarantor}
                >
                  <span>Kaydet</span>
                  <i className="t-icon-arrow-right2" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 999 }}></div>
      </>,
      document.body
    );
  };

  renderCorporateOfficerModal = () => {
    const { showCorporateOfficerModal, corporateOfficers, corporateOfficersLoading } = this.state;

    if (!showCorporateOfficerModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorModal t-officerPickerModal" style={{ display: "block", zIndex: 1100 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content t-guarantorModal-content border-0">
              <div className="t-guarantorModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon">
                    <i className="t-icon-users" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title">Kart Yetkilileri</h5>
                    <p className="t-guarantorModal-subtitle">Kefil olarak eklenecek kart yetkilisini seçiniz.</p>
                  </div>
                </div>
                <button type="button" className="t-guarantorModal-close" onClick={this.closeCorporateOfficerModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="t-guarantorModal-body t-officerPickerModal-body">
                {corporateOfficersLoading ? (
                  <EminevimLoading
                    compact
                    className="t-officerPickerModal-loading"
                    subtext="Kart yetkilileri yükleniyor, lütfen bekleyiniz."
                  />
                ) : (
                <div className="t-officerList">
                  {corporateOfficers.map((officer, index) => {
                    const adi = officer.adi || officer.Adi || "";
                    const soyadi = officer.soyadi || officer.Soyadi || "";
                    const fullName = `${adi} ${soyadi}`.trim() || "-";
                    const initials = [adi, soyadi]
                      .filter(Boolean)
                      .map((part) => part.charAt(0))
                      .join("")
                      .slice(0, 2)
                      .toUpperCase() || "?";
                    const tcNo = officer.tcNo || officer.TCNo || "-";
                    const telefon = this.formatPhone(officer.telefon || officer.Telefon || "");
                    const dogumTarihi = this.convertIsoToDisplayDate(officer.dogumTarihi || officer.DogumTarihi) || "-";
                    const key = officer.kartId || officer.KartId || officer.tcNo || officer.TCNo || index;
                    const isAlreadyAdded = officer.kefilEklenmisMi === true || officer.KefilEklenmisMi === true;

                    return (
                      <button
                        key={key}
                        type="button"
                        className={`t-officerList-item${isAlreadyAdded ? " t-officerList-item--disabled" : ""}`}
                        disabled={isAlreadyAdded}
                        onClick={() => this.selectCorporateOfficer(officer)}
                      >
                        <div className="t-officerList-main">
                          <div className="t-officerList-avatar" aria-hidden="true">{initials}</div>
                          <div className="t-officerList-info">
                            <strong className="t-officerList-name">{fullName}</strong>
                            <div className="t-officerList-metaRow">
                              <span className="t-officerList-chip">TC {tcNo}</span>
                              <span className="t-officerList-chip">{telefon || "-"}</span>
                              <span className="t-officerList-chip">{dogumTarihi}</span>
                            </div>
                            {isAlreadyAdded && (
                              <span className="t-officerList-warning">Bu kart yetkilisi üyeliğe daha önceden kefil olarak eklenmiş</span>
                            )}
                          </div>
                        </div>
                        {!isAlreadyAdded && (
                          <span className="t-officerList-select">
                            Seç
                            <i className="t-icon-arrow-right2" aria-hidden="true" />
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
                )}
              </div>
              <div className="t-guarantorModal-footer">
                <button
                  type="button"
                  className="t-guarantorModal-cancel"
                  onClick={this.closeCorporateOfficerModal}
                >
                  Vazgeç
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1099 }}></div>
      </>,
      document.body
    );
  };


  render() {
    const { members, membersInfoLoading } = this.props;
    const {
      deliveryDocuments,
      deliveryDocumentsLoading,
      isMemberTabsLoading,
    } = this.state;
    const showMemberTabsLoading = membersInfoLoading || isMemberTabsLoading;
    return (
      <>
        {this.renderPageLoadingOverlay()}

        <div className="" style={{ background: "white" }}>
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 3  EV */}

              {/* <div className={
                this.state.uye.orgTurId === 2 ? (
                  "row no-gutters t-kutu t-yesilCizgi"

                ) : this.state.uye.orgTurId === 3 ? (
                  "row no-gutters t-kutu t-turuncuCizgi"

                ) : this.state.uye.orgTurId === 1 ? (
                  "row no-gutters t-kutu t-mavicizgi"

                ) :
                  ("")
              }> */}
                <div className="col backbottom">
                  {/* içerikler */}
                  {this.renderMemberHeader()}
                  {showMemberTabsLoading ? (
                    this.renderMemberDetailLoading()
                  ) : (
                    <>
                  {/* tablı Sistem */}
                  <nav>
                    <div
                      className="nav nav-pills nav-fill nav-justified t-tablar"
                      id="nav-tab"
                      role="tablist"
                    >
                      <a
                        className={
                          this.state.uye.kayitTuruId === 8
                            ? "nav-link"
                            : "nav-link active"
                        }
                        data-toggle="tab"
                        data-target="#odemeler"
                        hidden={this.state.uye.kayitTuruId === 8}
                      >
                        ÖDEMELER
                      </a>
                      <a
                        className={
                          this.state.uye.kayitTuruId !== 8
                            ? "nav-link"
                            : "nav-link active"
                        }
                        data-toggle="tab"
                        data-target="#iadeler"
                        hidden={this.state.uye.kayitTuruId !== 8}
                      >
                        İADELER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#masraflar"
                      >
                        MASRAFLAR
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#hareketler"

                      >
                        HAREKETLER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#taksiterteleme"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          this.state.uye.dondurulanAy === null ||
                          this.state.uye.dondurulanAy === 0
                        }
                      >
                        TAKSİT ERTELEME
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#cekilisler"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.draws === null ||
                          members?.draws?.length === 0
                        }
                      >
                        ÇEKİLİŞLER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#teslimat"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.deliveryStatements?.list === null ||
                          members?.deliveryStatements?.list.length === 0
                        }
                      >
                        TESLİMAT DOSYA
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#teslimatFinans"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.deliveryFinancialStatements?.list === null ||
                          members?.deliveryFinancialStatements?.list.length === 0
                        }
                      >
                        TESLİMAT FİNANS
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#policeler"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.documents === null ||
                          members?.documents?.length === 0
                        }
                      >
                        POLİÇELER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#customerDocuments"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.customerDocuments === null ||
                          members?.customerDocuments?.length === 0
                        }
                      >
                        DOKÜMANLAR
                      </a>
                      <a
                        className="nav-link align-items-center"
                        data-toggle="tab"
                        data-target="#deliveryDocuments"
                        onClick={this.handleDeliveryDocumentsTabClick}
                        hidden={
                          members?.isShowDeliveryDocumentsWeb === false
                        }
                      >
                        DOKÜMAN YÜKLE
                      </a>
                      <a
                        className="nav-link align-items-center t-salesDocTabLink"
                        data-toggle="tab"
                        data-target="#salesDocuments"
                        onClick={this.handleSalesDocumentsTabClick}
                        hidden={members?.isShowUploadSalesDocuments === false}
                      >
                        <span className="t-salesDocNewRibbon" aria-hidden="true">YENİ</span>
                        SATIŞ DOKÜMANI YÜKLE
                      </a>
                    </div>
                  </nav>
                  <div className="tab-content p-2" id="nav-tabContent">
                    {/* Ödemeler Tablosu */}
                    <div
                      className={
                        this.state.uye.kayitTuruId === 8
                          ? "tab-pane fade table-responsive show"
                          : "tab-pane fade table-responsive show active"
                      }
                      id="odemeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Dönem</th>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">Ödenen ({this.state.currency})</th>
                            <th scope="col">Kalan ({this.state.currency})</th>

                          </tr>
                        </thead>
                        <tbody>
                          {members?.memberPayments?.list &&
                            members.memberPayments.list.map((item) => {
                              let classTaksit = "";
                              if (item.tur !== "TAKSIT" && item.kalanTutar !== 0)
                                classTaksit += "taksit_tipler";
                              if (item.tur !== "TAKSIT" && item.kalanTutar === 0)
                                classTaksit += " taksit_biten-tipler";
                              if (item.kalanTutar === 0)
                                classTaksit += " t-odendi";
                              return (
                                <tr key={item.id} className={classTaksit}>
                                  <td>
                                    {item.tur !== "TAKSIT" ? (
                                      <i className="t-icon-star-full"></i>
                                    ) : (
                                      item.donem
                                    )}
                                  </td>
                                  <td>{item.tur}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.kalanTutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" colSpan={2} />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.memberPayments?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.memberPayments?.kalanTutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* İadeler*/}
                    <div
                      className={
                        this.state.uye.kayitTuruId !== 8
                          ? "tab-pane fade table-responsive show"
                          : "tab-pane fade table-responsive show active "
                      }
                      id="iadeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">İade Edilen ({this.state.currency})</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.returns?.list &&
                            members.returns.list.map((item) => {
                              return (
                                <tr key={item.id} className="t-odendi">
                                  <td>{item.islemTipi}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.returns?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                      <p
                        className="small font-italic text-muted"
                        hidden={
                          members?.returns?.dilekceTarihi === null ||
                          members?.returns?.dilekceTarihi === ""
                        }
                      >
                        {members?.returns?.dilekceTarihi}
                      </p>
                    </div>
                    {/* Masraflar*/}
                    <div className="tab-pane fade table-responsive" id="masraflar">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">Ödenen ({this.state.currency})</th>
                            <th scope="col">Kalan ({this.state.currency})</th>

                          </tr>
                        </thead>
                        <tbody>
                          {members?.expenses?.list &&
                            members.expenses.list.map((item, index) => {
                              return (
                                <tr
                                  key={item.tur + item.vadeTarihi + "_" + index}
                                  className={
                                    item.kalanTutar === 0 ? "t-odendi" : ""
                                  }
                                >
                                  <td>{item.tur}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.kalanTutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.expenses?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.expenses?.kalanTutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* Hareketler*/}
                    <div className="tab-pane fade table-responsive" id="hareketler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">İşlem Tarihi</th>
                            <th scope="col">İşlem Tutarı ({this.state.currency})</th>
                            <th scope="col">Açıklama</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.movements &&
                            members.movements.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.islemTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>{item.aciklama}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {/*Taksit Erteleme*/}
                    <div className="tab-pane fade table-responsive" id="taksiterteleme">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Erteleme Sebebi</th>
                            <th scope="col">Ay</th>
                            <th scope="col">Detay</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.freeze?.list &&
                            members.freeze.list.map((item) => {
                              return (
                                <tr key={item.id} className="t-taksiterteleme">
                                  <td>{item.ertelenmeSebebi}</td>
                                  <td>{item.ay}</td>
                                  <td>
                                    <a
                                      href="#erteleme"
                                      onClick={() =>
                                        this.getFreezeDetail(item.kaynak)
                                      }

                                      data-toggle="modal"
                                      data-target="#ertelemeModalCenter"
                                    >
                                      Detay

                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.freeze?.toplamAy}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                      <br>
                      </br>
                      <p className="small font-italic text-muted">
                        {members?.freeze?.aciklama}
                      </p>
                      <p className="small font-italic text-muted">
                        {members?.freeze?.temsilciBilgi}
                      </p>
                    </div>
                    {/* Çekilişler*/}
                    <div className="tab-pane fade table-responsive" id="cekilisler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Çekiliş Tarihi</th>
                            <th scope="col">Çekiliş Durumu</th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>
                          {members?.draws &&
                            members.draws.map((item) => {
                              return (
                                <tr
                                  key={item.id}
                                  className={
                                    item.cekilisYapildiMi == true && item.ciktiMi ? "t-kazandiniz" : "t-cikmadi"
                                  }
                                >
                                  <td>
                                    {new Date(
                                      item.cekilisTarihi
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    {item.cekilisDurumu}
                                  </td>
                                  <td>
                                    <a
                                      href="#cekilis"
                                      hidden={item.cekilisYapildiMi == false}
                                      onClick={() =>
                                        this.setDrawId(item.id, item.cekilisTarihi)
                                      }
                                      data-toggle="modal"
                                      data-target="#cekilisModalCenter"

                                    >
                                      Detay

                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {/* Teslimat */}
                    <div className="tab-pane fade table-responsive" id="teslimat">
                      {/* Tamamlanma durumu için background divindeki width değeri ve yazının % cinsinden verilmesi gerekli*/}
                      <div className="row no-gutters">
                        <div className="col-12 py-2">
                          <div className="t-oran">
                            <div className="background"
                              style={{
                                width:
                                  members?.deliveryStatements?.tamamlanmaOrani +
                                  "%",
                              }}
                              aria-valuenow={
                                members?.deliveryStatements?.tamamlanmaOrani
                              }
                              aria-valuemin="0"
                              aria-valuemax="100" />
                            <span>
                              Tamamlanma durumu <strong className="px-2"> {members?.deliveryStatements?.tamamlanmaOrani} %{" "}</strong>

                            </span>

                          </div>


                        </div>
                        <div className="col-12 py-2">
                          <span style={{ fontSize: "initial" }}>
                            Yol haritasına ve gerekli evrak listesine ulaşmak için
                            <a

                              target="_blank"
                              href={
                                this.state.uye.orgTurId === 2
                                  ? process.env.PUBLIC_URL +
                                  "/assets/docs/evraklistesi-yolharitasi-konut 2_rgb.pdf"
                                  : process.env.PUBLIC_URL +
                                  "/assets/docs/evraklistesi-yolharitasi-otomobil 2_rgb.pdf"
                              }
                            >
                              <b> tıklayınız.</b>
                            </a>
                          </span>
                        </div>
                      </div>
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adımlar</th>
                            <th scope="col">Durum</th>
                            <th scope="col">Tamamlanma Tarihi</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.deliveryStatements?.list &&
                            members.deliveryStatements.list.map((item) => {
                              return (
                                <tr
                                  key={item.id}
                                  className={item.isDurum ? "t-tamamlandi" : "t-eksik"}
                                >
                                  <td className="text-left">{item.isTuru}</td>
                                  <td>
                                    {item.isDurum ? (
                                      <i className="t-icon-check_circle_outline"></i>
                                    ) : (
                                      <i className="far fa-times-circle text-danger"></i>
                                    )}
                                  </td>
                                  <td>{item.tamamlanmaTarihi}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>


                    {/* Teslimat Finans*/}
                    <div className="tab-pane fade" id="teslimatFinans">
                      {/* Tamamlanma durumu için background divindeki width değeri ve yazının % cinsinden verilmesi gerekli*/}
                      <div className="row no-gutters">
                        <div className="col-12 py-2">
                          <div className="t-oran">
                            <div className="background"
                              style={{
                                width:
                                  members?.deliveryFinancialStatements?.tamamlanmaOrani +
                                  "%",
                              }}
                              aria-valuenow={
                                members?.deliveryFinancialStatements?.tamamlanmaOrani
                              }
                              aria-valuemin="0"
                              aria-valuemax="100" />
                            <span>
                              Tamamlanma durumu <strong className="px-2"> {members?.deliveryFinancialStatements?.tamamlanmaOrani} %{" "}</strong>

                            </span>

                          </div>


                        </div>
                        {/* <div className="col-12 py-2">
                        <span style={{ fontSize: "initial" }}>
                          Yol haritasına ve gerekli evrak listesine ulaşmak için
                          <a

                            target="_blank"
                            href={
                              this.state.uye.orgTurId === 2
                                ? process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-konut 2_rgb.pdf"
                                : process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-otomobil 2_rgb.pdf"
                            }
                          >
                            <b> tıklayınız.</b>
                          </a>
                        </span>
                      </div> */}
                      </div>

                      {members?.deliveryFinancialStatements?.list &&
                        members.deliveryFinancialStatements.list.map((item, index) => {
                          return (
                            <div key={"base_" + index}>
                              <div className="table-responsive" style={{ backgroundColor: "#efefef", padding: "4px", fontSize: "12pt", fontWeight: "600", width: "100%" }}>Teslimat Id : {item.teslimatKesintiId}</div>
                              <table className="table table-sm t-tablo">
                                <thead>
                                  <tr>
                                    <th className="text-left" scope="col">Adımlar</th>
                                    <th scope="col" width="150">Durum</th>
                                    <th scope="col" width="150">Tamamlanma Tarihi</th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {item.list.map((item2) => {
                                    return (
                                      <tr
                                        key={item2.id}
                                        className={item2.isDurum ? "t-tamamlandi" : "t-eksik"}
                                      >
                                        <td className="text-left">{item2.isTuru}</td>
                                        <td>
                                          {item2.isDurum ? (
                                            <i className="t-icon-check_circle_outline"></i>
                                          ) : (
                                            <i className="far fa-times-circle text-danger"></i>
                                          )}
                                        </td>
                                        <td>{item2.isDurum ? item2.tamamlanmaTarihi : "-"}</td>
                                      </tr>
                                    );
                                  })}

                                </tbody>
                              </table>
                            </div>
                          );
                        })

                      }

                    </div>

                    {/* Poliçeler*/}
                    <div className="tab-pane fade table-responsive" id="policeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adı</th>
                            <th scope="col">Türü</th>
                            <th scope="col">Eklenme Tarihi</th>
                            <th scope="col" >İndir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.documents &&
                            members.documents.map((item) => {
                              return (
                                <tr key={item.id} className="t-policeler">
                                  <td className="text-left">{item.dosyaAdi}</td>
                                  <td>{item.dokumanTurAdi}</td>
                                  <td>{item.tarihText}</td>
                                  <td>
                                    <a
                                      href="#indir"
                                      onClick={() => this.getDocumentFile(item.id, item.dosyaAdi)}
                                    >
                                      <i className="t-icon-folder-download"></i> İndir
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}

                        </tbody>
                      </table>
                    </div>


                    {/* customerDocuments */}
                    <div className="tab-pane fade table-responsive" id="customerDocuments">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adı</th>
                            <th scope="col">Türü</th>
                            <th scope="col">Eklenme Tarihi</th>
                            <th scope="col" >İndir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.customerDocuments &&
                            members.customerDocuments.map((item) => {
                              return (
                                <tr key={item.id} className="t-policeler">
                                  <td className="text-left">{item.dosyaAdi}</td>
                                  <td>{item.dokumanTurAdi}</td>
                                  <td>{item.tarihText}</td>
                                  <td>
                                    <a
                                      href="#indir"
                                      onClick={() => this.getDocumentFile(item.id, item.dosyaAdi)}
                                    >
                                      <i className="t-icon-folder-download"></i> İndir
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}

                        </tbody>
                      </table>
                    </div>




                    {/* deliveryDocuments */}
                    <div className="tab-pane fade table-responsive mt-2" id="deliveryDocuments">
                      {deliveryDocumentsLoading ? (
                        this.renderDeliveryDocumentsLoading()
                      ) : deliveryDocuments ? (
                        <>
                          <div className="d-flex justify-content-end mb-2">
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              title="Muvafakatname ve Nüfus Kayıt Örneğini Nasıl Alırım ?"
                              onClick={this.openDeliveryDocumentsInfo}
                              hidden={deliveryDocuments.ekranTuru !== 3 || deliveryDocuments.secilenOrgId !== 2}
                            >
                              <i className="t-icon-info_outline mr-1" />
                              Muvafakatname ve Nüfus Kayıt Örneğini Nasıl Alırım ?
                            </button>
                          </div>
                          {deliveryDocuments.ekranTuru === 1 && this.renderDeliveryStatusAlert(deliveryDocuments)}
                          {deliveryDocuments.ekranTuru === 2 && this.renderDeliveryScopeSelection()}
                          {deliveryDocuments.ekranTuru === 4 && this.renderServiceRecordSelection()}
                          {deliveryDocuments.ekranTuru === 3 && this.renderDeliveryDocumentsContent()}
                        </>
                      ) : (
                        <div className="text-center p-4 text-muted">Doküman bilgileri yüklenmedi.</div>
                      )}
                    </div>

                    <div className="tab-pane fade table-responsive mt-2" id="salesDocuments">
                      <SalesDocumentUploadTab
                        ref={this.salesDocumentTabRef}
                        memberId={this.props.match?.params?.id}
                        onListLoaded={this.handleSalesDocumentsListLoaded}
                      />
                    </div>

                  </div>
                    </>
                  )}
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              {/* KUTU 2 BİTTİ */}
              <DrawDetail cekilisTarihi={this.state.cekilisTarihi}></DrawDetail>
              <FreezeDetail></FreezeDetail>

              {this.renderDeliveryDocumentsInfoModal()}
              {this.renderDeliveryScopeConfirmModal()}
              {this.renderDeleteGuarantorModal()}
              {this.renderGuarantorCriteriaWarningModal()}
              {this.renderGuarantorChoiceModal()}
              {this.renderAddGuarantorModal()}
              {this.renderCorporateOfficerModal()}
              {this.renderOfficerGuarantorConfirmModal()}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <div className="row" style={{ height: 30 }} />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
    members: selectMembersInfo(state),
    membersInfoLoading: selectMembersInfoLoading(state),
    file: selectDocumentFile(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMembersInfo: (memberId) => dispatch(getMembersInfo(memberId)),
  getDrawDetail: (memberId, drawId) =>
    dispatch(getDrawDetail(memberId, drawId)),
  getFreezeDetail: (memberId, sourceId) =>
    dispatch(getFreezeDetail(memberId, sourceId)),
  getDocumentFile: (documentId, ext, documentName) => dispatch(getDocumentFile(documentId, ext, documentName)),
  downloadCdnFile: (id, memberId, ext, documentName) => dispatch(downloadCdnFile(id, memberId, ext, documentName)),
  downloadReportFile: (uyelikId, raporId, ext, documentName) => dispatch(downloadReportFile(uyelikId, raporId, ext, documentName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Expenses);
